import React from 'react';
import {classes, style} from './doppe-coupon-popup.st.css';
import {ButtonType, reactCreateMemo } from '@wix/devzai-utils-react';

import {
    CouponSourceType,
    DoppeActionTypeCouponView
} from '../doppe-action-type-coupon-view/doppe-action-type-coupon-view';
import {
    DoppeActionTypeWidgetInnerButton
} from '../doppe-action-type-widget-inner-button/doppe-action-type-widget-inner-button';
import {CommonClasses, FlexLayout} from '@wix/devzai-common-client';
import {DoppeDtoBymoLinkId} from '../../client-server-common';
import {DoppeViewerAppIconDismissMedium} from '../doppe-viewer-icons/doppe-viewer-icons';
import {DoppeViewerHorizontalButton} from '../doppe-viewer-horizontal-button/doppe-viewer-horizontal-button';
import {useDoppeViewerLocales} from "../../client/doppe-viewer-locales/doppe-viewer-locales";

export const DoppeCouponPopup = reactCreateMemo(function DoppeCouponPopup(
    props: DoppeCouponPopup.Props
) {
    const {
        couponCode,
        couponTitle,
        couponDescription,
        couponUrl,
        onLinkClicked,
        onCouponCopied,
        onClose,
        linkId,
        showBackToButton = true,
        showCloseButton = false,

        className,
        ...htmlAttributes
    } = props;


    const doppeViewerLocales = useDoppeViewerLocales();

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, {}, className, FlexLayout.column.default)}
        >
            {couponTitle !== '' || couponDescription !== '' ? (
                <div
                    className={style(classes.couponNameAndDescription, {})}
                >
                    {couponTitle !== '' ? (
                        <div
                            className={style(classes.couponName, {})}
                        >
                            {couponTitle}
                        </div>
                    ) : null}
                    {couponDescription !== '' ? (
                        <div
                            className={style(classes.couponDescription, {})}
                        >
                            {couponDescription}
                        </div>
                    ) : null}
                </div>
            ) : null}
            <DoppeActionTypeCouponView
                className={style(classes.couponView, {})}
                coupon={couponCode}
                couponSourceType={CouponSourceType.SearchLink}
                actionId={linkId}
                onCouponCopied={onCouponCopied}
            />
            <DoppeActionTypeWidgetInnerButton
                className={style(classes.linkButton)}
                buttonType={ButtonType.NormalButton}
                inPopup={true}
                tagName={onLinkClicked ? 'a' : undefined}
                href={onLinkClicked ? couponUrl ?? '' : undefined}
                target={onLinkClicked ? '_blank' : undefined}
                onClick={() => {
                    onLinkClicked?.();
                    onClose?.();
                }}
            >
                {doppeViewerLocales['continue']}
            </DoppeActionTypeWidgetInnerButton>
            {
                showBackToButton ?
                    <div
                        className={style(classes.backToSearch, {}, FlexLayout.centerContent)}
                    >
                        <div
                            className={style(classes.closeButton, {}, CommonClasses.button)}
                            onClick={onClose}
                        >
                            {showBackToButton}
                        </div>
                    </div>
                    :
                    false
            }
            {
                showCloseButton ?
                    <DoppeViewerHorizontalButton
                        className={style(classes.dismissButton, {})}
                        prefixIcon={DoppeViewerAppIconDismissMedium}
                        textual={true}
                        onClick={() => {
                            onClose?.();
                        }}
                    />
                    :
                    null
            }
        </div>
    )
});

export namespace DoppeCouponPopup {

    export interface Props extends React.HTMLAttributes<any> {
        couponCode: string;
        couponTitle: string;
        couponDescription: string;
        couponUrl: string | null;
        linkId: DoppeDtoBymoLinkId,
        onLinkClicked?: () => void;
        onCouponCopied?: () => void;
        onClose?: () => void;
        showBackToButton?: string;
        showCloseButton?: boolean;
    }
}
